export default __webpack_public_path__ + "static/j-miller-min-3bfd56e755697b8276b4efdd86937acf.png";